$(document).on('click', '[data-customer-item-children-toggle]', (event) => {
  const $target = $(event.target);
  $target.closest('article').next().toggleClass('hide');
  $target.toggleClass('icon-arrow-down');
  $target.toggleClass('icon-arrow-up');
});
